module.exports = __webpack_public_path__ + "img/Foto_Press_Release_KasPro_x_IZILOH_1.cb4b152d.jpeg";